import type { ILegalContentConstructorParams } from "@services/sdk";
import { map } from "ramda";

export enum LegalTypeEnum {
	SHORTTERMSCONDITIONS = "short-terms-and-conditions",
	TERMSCONDITIONS = "terms-and-conditions",
	CRITICALINFO = "critical-information-summary",
	PRIVACY = "privacy-policy",
	ABOUTFELIX = "about-felix",
	PORTINTERMS = "portin-terms",
	REFERRALTERMS = "referral-terms",
	SPEED = "speed",
}

class LegalContent {
	public static ConstructList(
		arrParams: Array<ILegalContentConstructorParams>,
	): Array<LegalContent> {
		return map(LegalContent.Construct)(arrParams);
	}

	public static Construct(
		params: ILegalContentConstructorParams,
	): LegalContent {
		return new LegalContent(params);
	}

	responseData: ILegalContentConstructorParams;

	constructor(params: ILegalContentConstructorParams) {
		this.responseData = params;
	}

	get headline(): string {
		return this.responseData.headline;
	}

	get copy(): object {
		return this.responseData.copy;
	}

	get key(): string {
		return this.responseData.key;
	}
}

export default LegalContent;
